import React from "react";

import DisplayImage from "./DisplayImage";
import DownloadingImage from "./DownloadingImage";
import NoImage from "./NoImage";
import ProcessingImage from "./ProcessingImage";
import UploaderForImages from "./UploaderForImages";
import UploadingImage from "./UploadingImage";

const ImageUploader = (props: any) => {
    const components = [
        NoImage,
        UploadingImage,
        ProcessingImage,
        DownloadingImage,
        DisplayImage
    ];
    return (
        <UploaderForImages
            id={props.id}
            handleChange={props.handleChange}
            image={props.image}
            type={props.type}
            components={components}
            {...props}
        />
    );
};

export default ImageUploader;
